import { Button, Center, Skeleton } from '@chakra-ui/react';
import { createColumnHelper } from '@tanstack/react-table';
import MerchantConsultationDatatableRowMeta from "@Modules/terminalManagementSystem/merchant/containers/tableHandlers/merchantConsultation/MerchantConsultationDatatableRowMeta";
import CustomDataTableInfoBtn from '@Modules/core/components/table/CustomDataTableInfoBtn';
import { CustomButton } from '@Modules/core/components';

export type TMerchantConsultationDataTableData = {
    primaryKey: string | number,
    date: string,
    MCC: string,
    merchantId: string,
    DBAName: string,
    status: string,
    pos: string,
    iron: string,
    paymentMode: string,
    [x: string]: any,
};

type Props = {
  isLoading: boolean | undefined,
  handleEdit: (row: any) => void,
  displayDetails: (row: any) => void,
};

const columnHelper = createColumnHelper<TMerchantConsultationDataTableData>()

export function getMerchantConsultationDataTableColumns({ isLoading, handleEdit, displayDetails }: Props) {
  
  return [
    columnHelper.accessor("date",
        {
            id: "date",
            header: "Date",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("MCC",
        {
            id: "MCC",
            header: "MCC",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("merchantId",
        {
            id: "merchantId",
            header: "ID Commercant",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("DBAName",
        {
            id: "DBAName",
            header: "D/B/A Nom",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("status",
        {
            id: "status",
            header: "Statut",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("pos",
        {
            id: "pos",
            header: "Pos",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("iron",
        {
            id: "iron",
            header: "Fer a repasser",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("paymentMode",
        {
            id: "paymentMode",
            header: "Mode paiement",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),

    columnHelper.display(
        {
            id: "action",
            header: "",
            cell: props => {
                return (
                    <Skeleton isLoaded={!isLoading}>
                        <Center display={'flex'} gap={5}>
                        <CustomButton
                            size={'sm'}
                            onClick={() => handleEdit(props.row)}                            
                        >
                            Details
                        </CustomButton>
                        <CustomDataTableInfoBtn disabled={isLoading} onClick={() => displayDetails(props.row)} />
                        </Center>
                    </Skeleton>
                );
            }
        }

    ),
  ];
}
